import React from "react";
import Loadable from "react-loadable";

import DotSpinner from "@exovera/dot-spinner";

function Loading() {
	return (
		<div className="breadcrumb__loader">
			<DotSpinner color="#1cc2ff" />
		</div>
	);
}
const ChinaTinyMapLoader = Loadable.Map({
	loader: {
		Breadcrumb: () => import(/* webpackChunkName: "tinyMap" */ "components/Breadcrumb"),
		baseIcon: () => import(/* webpackChunkName: "tinyMap" */ "lib/maps/tinyChina.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const { actions } = props;
		const Breadcrumb = loaded.Breadcrumb.default;
		const baseIcon = loaded.baseIcon.default;
		return (
			<Breadcrumb
				baseIcon={baseIcon}
				stateName={props.stateName}
        changeMap={actions.changeMap}
        mapId="China"
        mapStateIdPrefix="CN"
        nameTop="39px"
        nameLeft="0px"
        invert
			/>
		);
	},
});

export default ChinaTinyMapLoader;
